import { CompanyTitledPage } from "../TitledPage";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../components/PartHeader";
import CommodityOwnerNewForm from "./CommodityOwnerNewForm";
import { INITIAL_COMMODITY } from "./commodityInitial";

import React, { useRef } from "react";
import { getBankAccount } from "../../http/api/BankAPI";
import { updateCommodityOwner } from "../../http/api/CommodityOwnerAPI";
import { postCommodityOwnerInvoiceRegistrationHistorySearchInfoListAPI } from "../../http/api/CommodityOwnerInvoiceRegistrationHistoryAPI";
import LoadingModal from "../../components/LoadingModal";

const infoTableCellSx = {
  fontSize: 18,
};

// 新規荷主更新ページ
const CommodityOwnerEditPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [initialValues, setInitialValue] = useState(INITIAL_COMMODITY);
  const [isLoading, setLoading] = useState(true);
  const formRef = useRef();
  const refs = useRef({});
  useEffect(() => {
    Object.keys(initialValues).forEach((key) => {
      refs.current[key] = React.createRef(initialValues[key]);
    });
  }, [initialValues]);
  useEffect(() => {
    initialEditForm();
  }, [location.state.commodityOwnerInfo]);

  async function initialEditForm() {
    let initialValues = {};
    const commodityOwnerInfo = location.state.commodityOwnerInfo;
    const commodityOwnerCd = commodityOwnerInfo.commodityOwnerCd;
    if (!commodityOwnerCd) {
      return;
    }
    const bankInfoResponse = await getBankAccount({ commodityOwnerCd });
    const listBank = bankInfoResponse.data ?? bankInfoResponse;
    const bankInfo = listBank[0] || {};

    const registrationHistoryResponse = await postCommodityOwnerInvoiceRegistrationHistorySearchInfoListAPI({ commodityOwnerCd });
    const invoiceRegistrationHistoryList
      = registrationHistoryResponse.invoiceRegistrationHistoryList
        .map((historyInfo) => ({
          registrationHistoryId: historyInfo.registrationHistoryId,
          registrationDate: historyInfo.registrationDate,
          cancellationDate: historyInfo.cancellationDate,
          isDeleted: false,
        }))

    initialValues = { ...commodityOwnerInfo, ...bankInfo, invoiceRegistrationHistoryList };
    setInitialValue((prev) => ({...prev, ...initialValues}));

    setTimeout(()=>{
      setLoading(false);
    }, 200)
    
  }

  const handleClickReturn = (event) => {
    navigate(-1);
  };
  // 更新ボタンをクリックするイベント
  async function handleClickUpdate() {
    try {
      formRef.current.setTouched(
        Object.keys(formRef.current.values).reduce(
          (touched, key) => ({ ...touched, [key]: true }),
          {}
        )
      );
      await formRef.current.validateForm();
      const errors = formRef.current.errors;
      const hasErrors = errors && Object.keys(errors).length > 0;

      if (hasErrors) {
        alert("入力不正項目があるため、ご確認お願い致します。");
      } else {
        let updateValues = formRef.current;
        Object.keys(refs.current).forEach((key) => {
          const element = refs.current[key].current;
          if (element) {
            if (key === "areaCd") {
              updateValues[key] = element.value === -1 ? null : element.value;
            } else{
              updateValues[key] = element.value;
            }
          }
        });

        updateValues.updatedId = 1;
        updateValues.invoiceRegistrationHistoryList
          = formRef.current.values.invoiceRegistrationHistoryList
            .map((h => ({
              ...h,
              registrationDate: h.registrationDate || null,
              cancellationDate: h.cancellationDate || null,
            })));

        console.log("Update CommodityOwner data : ", updateValues);
        let response = await updateCommodityOwner(updateValues);
        alert("荷主を編集しました。");
        navigate("/company/commodity_owner");
      }
    } catch {
      alert("荷主を編集できませんでした。");
    }
  }

  return (
    <CompanyTitledPage title="荷主編集">
      <LoadingModal open={isLoading} label={"取得中"} />
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              荷主情報の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={handleClickUpdate}
              id="commodity-owner-form-submit-button"
            >
              更新
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={handleClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      {/* 荷主情報 */}
      <CommodityOwnerNewForm
        innerRef={formRef}
        commodityOwnerInfo={initialValues}
        refs={refs}
        isUpdateMode={true}
      />
    </CompanyTitledPage>
  );
};

export default CommodityOwnerEditPage;
